import React, { useState } from "react";
import "./style.css";

export default function AboutImporterr() {
  // State for expand/collapse on mobile (all sections collapsed by default)
  const [expandedSections, setExpandedSections] = useState({
    intro: false,
    whyImporterr: false,
    quickSearches: false,
    assetLite: false,
    story: false,
  });

  // URL mapping for clickable chips (Popular Categories & Trending Searches)
  const chipUrlMap = {
    // Popular Categories
    "Home & Kitchen": "/collection?category=global&search=Home%20&",
    Lifestyle: "/collection?category=global&search=Lifestyle&",
    "Fashion Accessories":
      "/collection?category=global&search=Fashion%20Accessories&",
    "Beauty Tools": "/collection?category=global&search=Beauty%20Tools&",
    Gifting: "/collection?category=global&search=Gifting&",
    "Décor": "/collection?category=global&search=Décor&",
    "Personal Care": "/collection?category=global&search=Personal%20Care&",
    "Travel Essentials":
      "/collection?category=global&search=Travel%20Essentials&",
    "Storage & Organizers":
      "/collection?category=global&search=Storage%20&",
    "Daily Utility Products":
      "/collection?category=global&search=Daily%20Utility%20Products&",

    // Trending Searches
    "Makeup Tools": "/collection?category=global&search=Makeup%20Tools&",
    "Hair Curler": "/collection?category=global&search=Hair%20Curler&",
    "Vanity Mirror": "/collection?category=global&search=Vanity%20Mirror&",
    "Travel Pouch": "/collection?category=global&search=Travel%20Pouch&",
    "Storage Organizer":
      "/collection?category=global&search=Storage%20Organizer&",
    "Sling Bag": "/collection?category=global&search=Sling%20Bag&",
    "Portable Fan": "/collection?category=global&search=Portable%20Fan&",
    "Beauty Accessories":
      "/collection?category=global&search=Beauty%20Accessories&",
    "Water Bottle": "/collection?category=global&search=Water%20Bottle&",
    "Gift Items": "/collection?category=global&search=Gift%20Items&",
  };

  const getChipUrl = (label) => {
    if (chipUrlMap[label]) return chipUrlMap[label];
    // Fallback (not used for your specified labels, but safe to have)
    return `/collection?category=global&search=${encodeURIComponent(
      label
    )}&`;
  };

  const handleChipClick = (label) => {
    const url = getChipUrl(label);
    window.location.href = url;
  };

  // Toggle section expansion on mobile
  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <section className="after-footer-about">
      <div className="afa-container">
        {/* INTRO / HERO COPY */}
        <section className="afa-section">
          <div 
            className="afa-section-header" 
            onClick={() => toggleSection('intro')}
          >
            <h2 className="afa-heading">
              GLOBAL SOURCING MADE SIMPLE WITH IMPORTERR
            </h2>
            <span className="afa-toggle-icon">
              {expandedSections.intro ? '−' : '+'}
            </span>
          </div>
          <div className={`afa-section-content ${expandedSections.intro ? 'expanded' : 'collapsed'}`}>
            <div className="afa-body">
              <p>
                Welcome to Importerr, your trusted global B2B sourcing partner for
                businesses, retailers, D2C brands, and entrepreneurs across India.
                Whether you're a startup, wholesaler, small business, or online
                seller, Importerr makes global product sourcing effortless,
                transparent, and risk-free. With access to 120+ million products
                from verified global suppliers, we help you import directly from
                China and other countries — all with 1-piece MOQ (minimum order
                quantity).
              </p>
              <p>
                Start sourcing trending, high-quality products without worrying
                about bulk orders or high inventory costs. Importerr helps you
                test products, launch new categories, and scale your business in
                an asset-lite model — all from the comfort of your home or office.
              </p>
            </div>
          </div>
        </section>

        {/* WHY IMPORTERR */}
        <section className="afa-section">
          <div 
            className="afa-section-header" 
            onClick={() => toggleSection('whyImporterr')}
          >
            <h2 className="afa-heading">
              WHY IMPORTERR IS INDIA'S #1 CROSS-BORDER SOURCING PLATFORM
            </h2>
            <span className="afa-toggle-icon">
              {expandedSections.whyImporterr ? '−' : '+'}
            </span>
          </div>
          <div className={`afa-section-content ${expandedSections.whyImporterr ? 'expanded' : 'collapsed'}`}>
            <p className="afa-point-text afa-para">
              At Importerr, we simplify the entire sourcing journey — from finding
              products to shipping them right to your doorstep.
            </p>
            <div className="afa-grid two-col">
              <div className="afa-col">
                <div className="afa-point">
                  <div className="afa-point-title">
                    Direct Sourcing, No Middlemen
                  </div>
                  <div className="afa-point-text">
                    Get connected directly to trusted global suppliers without
                    hidden markups or agent fees.
                  </div>
                </div>

                <div className="afa-point">
                  <div className="afa-point-title">1-Piece MOQ Advantage</div>
                  <div className="afa-point-text">
                    Test new ideas and products without locking capital in bulk
                    inventory. Perfect for startups, D2C brands, and eCommerce
                    sellers.
                  </div>
                </div>

                <div className="afa-point">
                  <div className="afa-point-title">Global Reach</div>
                  <div className="afa-point-text">
                    Access millions of wholesale and trending products across
                    categories — from electronics, gadgets, lifestyle, kitchenware,
                    accessories, home décor, and beauty tools to industrial and B2B
                    supplies.
                  </div>
                </div>
              </div>

              <div className="afa-col">
                <div className="afa-point">
                  <div className="afa-point-title">End-to-End Support</div>
                  <div className="afa-point-text">
                    Our team handles product procurement, quality check,
                    consolidation, and shipping, making importing completely
                    hassle-free.
                  </div>
                </div>

                <div className="afa-point">
                  <div className="afa-point-title">
                    Secure Payments & Fast Delivery
                  </div>
                  <div className="afa-point-text">
                    Pay safely in INR through verified channels, and get your
                    goods delivered within committed timelines.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* QUICK SEARCHES */}
        <section className="afa-section">
          <div 
            className="afa-section-header" 
            onClick={() => toggleSection('quickSearches')}
          >
            <h2 className="afa-heading">QUICK SEARCHES</h2>
            <span className="afa-toggle-icon">
              {expandedSections.quickSearches ? '−' : '+'}
            </span>
          </div>
          <div className={`afa-section-content ${expandedSections.quickSearches ? 'expanded' : 'collapsed'}`}>
            <div className="afa-grid three-col">
              {/* Popular Categories */}
              <div className="afa-col">
                <div className="afa-subhead">Popular Categories</div>
                <ul className="afa-chip-list">
                  <li onClick={() => handleChipClick("Home & Kitchen")}>
                    Home &amp; Kitchen
                  </li>
                  <li onClick={() => handleChipClick("Lifestyle")}>Lifestyle</li>
                  <li
                    onClick={() => handleChipClick("Fashion Accessories")}
                  >
                    Fashion Accessories
                  </li>
                  <li onClick={() => handleChipClick("Beauty Tools")}>
                    Beauty Tools
                  </li>
                  <li onClick={() => handleChipClick("Gifting")}>Gifting</li>
                  <li onClick={() => handleChipClick("Décor")}>Décor</li>
                  <li onClick={() => handleChipClick("Personal Care")}>
                    Personal Care
                  </li>
                  <li onClick={() => handleChipClick("Travel Essentials")}>
                    Travel Essentials
                  </li>
                  <li
                    onClick={() => handleChipClick("Storage & Organizers")}
                  >
                    Storage &amp; Organizers
                  </li>
                  <li
                    onClick={() => handleChipClick("Daily Utility Products")}
                  >
                    Daily Utility Products
                  </li>
                </ul>
              </div>

              {/* Trending Searches */}
              <div className="afa-col">
                <div className="afa-subhead">Trending Searches</div>
                <ul className="afa-chip-list">
                  <li onClick={() => handleChipClick("Makeup Tools")}>
                    Makeup Tools
                  </li>
                  <li onClick={() => handleChipClick("Hair Curler")}>
                    Hair Curler
                  </li>
                  <li onClick={() => handleChipClick("Vanity Mirror")}>
                    Vanity Mirror
                  </li>
                  <li onClick={() => handleChipClick("Travel Pouch")}>
                    Travel Pouch
                  </li>
                  <li onClick={() => handleChipClick("Storage Organizer")}>
                    Storage Organizer
                  </li>
                  <li onClick={() => handleChipClick("Sling Bag")}>
                    Sling Bag
                  </li>
                  <li onClick={() => handleChipClick("Portable Fan")}>
                    Portable Fan
                  </li>
                  <li onClick={() => handleChipClick("Beauty Accessories")}>
                    Beauty Accessories
                  </li>
                  <li onClick={() => handleChipClick("Water Bottle")}>
                    Water Bottle
                  </li>
                  <li onClick={() => handleChipClick("Gift Items")}>
                    Gift Items
                  </li>
                </ul>
              </div>

              {/* Top B2B Searches - NO CLICK FUNCTIONALITY */}
              <div className="afa-col">
                <div className="afa-subhead">Top B2B Searches</div>
                <ul className="afa-chip-list">
                  <li>Import from China</li>
                  <li>B2B Sourcing Platform India</li>
                  <li>1 MOQ Supplier</li>
                  <li>Cross-Border Import</li>
                  <li>Small Business Product Sourcing</li>
                  <li>Private Label Sourcing</li>
                  <li>Wholesale Lifestyle Products</li>
                  <li>Import Partner for Indian Sellers</li>
                  <li>Global Product Sourcing</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ASSET-LITE SOURCING */}
        <section className="afa-section">
          <div 
            className="afa-section-header" 
            onClick={() => toggleSection('assetLite')}
          >
            <h2 className="afa-heading">
              ASSET-LITE SOURCING FOR INDIAN ENTREPRENEURS
            </h2>
            <span className="afa-toggle-icon">
              {expandedSections.assetLite ? '−' : '+'}
            </span>
          </div>
          <div className={`afa-section-content ${expandedSections.assetLite ? 'expanded' : 'collapsed'}`}>
            <div className="afa-body">
              <p>
                Importerr follows an asset-lite sourcing model, designed to
                support D2C brands, startups, and small retailers in India. You
                can test, list, and sell new products on Amazon, Meesho,
                Flipkart, or Shopify — without bulk buying or warehouse
                management.
              </p>
            </div>

            <div className="afa-grid four-col afa-highlights">
              <div className="afa-highlight-card">
                <div className="afa-highlight-text">
                  Get direct access to international factories and suppliers
                </div>
              </div>
              <div className="afa-highlight-card">
                <div className="afa-highlight-text">
                  Receive quotations within 24 hours
                </div>
              </div>
              <div className="afa-highlight-card">
                <div className="afa-highlight-text">
                  Import small or single-piece quantities
                </div>
              </div>
              <div className="afa-highlight-card">
                <div className="afa-highlight-text">
                  Enjoy doorstep delivery anywhere in India
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* STORY / ORIGIN */}
        <section className="afa-section">
          <div 
            className="afa-section-header" 
            onClick={() => toggleSection('story')}
          >
            <h2 className="afa-heading">
              FROM AN IDEA TO INDIA'S CROSS-BORDER SOURCING PARTNER
            </h2>
            <span className="afa-toggle-icon">
              {expandedSections.story ? '−' : '+'}
            </span>
          </div>
          <div className={`afa-section-content ${expandedSections.story ? 'expanded' : 'collapsed'}`}>
            <div className="afa-body">
              <p>
                Built on the vision to make global sourcing accessible to every
                Indian business, Importerr started with a simple idea — to
                remove the barriers between small sellers and global factories.
              </p>
              <p>
                What began as a sourcing support initiative quickly grew into a
                full-scale cross-border platform, helping thousands of Indian
                sellers access verified suppliers, transparent pricing, and
                secure shipping — all through a single interface.
              </p>
              <p>
                Today, Importerr stands as a reliable sourcing partner for
                retailers, D2C brands, and eCommerce entrepreneurs, providing
                them with the tools, trust, and transparency needed to compete
                globally.
              </p>
              <p>
                With continuous technological improvements, dedicated sourcing
                experts, and a growing product database, Importerr is shaping
                the future of asset-lite, borderless trade for Indian
                businesses.
              </p>
            </div>
          </div>
        </section>

        {/* CONTACT & SUPPORT - Always visible, no expand/collapse */}
        <section className="afa-section">
          <div className="afa-section-header-no-toggle">
            <h2 className="afa-heading">CONTACT & SUPPORT</h2>
          </div>
          <div className="afa-section-content">
            <div className="afa-support-card">
              <div className="afa-body">
                <p>
                  Experience effortless global sourcing with Importerr. From
                  AI-powered product discovery to doorstep delivery, we are your
                  trusted partner in building and scaling your business.
                </p>
              </div>

              <ul className="afa-support-list">
                <li>
                  <span className="afa-label">Customer Support:</span> Guidance
                  for sourcing, logistics, and order management.
                </li>
                <li>
                  <span className="afa-label">Secure Payments:</span> Multiple,
                  safe payment options.
                </li>
                <li>
                  <span className="afa-label">Real-Time Tracking:</span> Monitor
                  your shipments from supplier to delivery.
                </li>
                <li>
                  <span className="afa-label">Flexible Solutions:</span>{" "}
                  Catering to businesses, startups, and individual entrepreneurs
                  alike.
                </li>
                <li>
                  <span className="afa-label">For Chinese Supplier:</span>{" "}
                  <a href="https://xporterr.com" target="_blank" rel="noopener noreferrer">
                    www.xporterr.com
                  </a>
                </li>
                <li>
                  <span className="afa-label">Canton 2026:</span>{" "}
                  <a href="https://importerr.com/canton2026" target="_blank" rel="noopener noreferrer">
                    www.importerr.com/canton2026
                  </a>
                </li>                
              </ul>

              <div className="afa-contact-grid">
                <div className="afa-contact-item">contact@importerr.com</div>
                <div className="afa-contact-item">+91 7827842406</div>
                <div className="afa-contact-item">www.importerr.com</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}
